import { DivisionSearchRequest, DivisionDto, UpsertDivisionDto
} from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/divisions`;

export const searchDivisions = (divisionSearchRequest: Partial<DivisionSearchRequest>,
                                source: CancelTokenSource): Promise<Array<DivisionDto>> => {
  return axios
      .post(`${apiUri}/search`, divisionSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findDivisionById = (id: number, source: CancelTokenSource): Promise<UpsertDivisionDto> => {
  return axios
      .get(`${apiUri}/${id}`,{cancelToken: source.token})
      .then( response => response.data)
};

export const saveDivision = (upsertDivisionDto: Partial<UpsertDivisionDto>, source: CancelTokenSource): Promise<UpsertDivisionDto> => {
  return axios
      .post(apiUri, upsertDivisionDto, {cancelToken: source.token})
      .then( response => response.data);
};

export const editDivision = (id: number, upsertDivisionDto: Partial<UpsertDivisionDto>, source: CancelTokenSource): Promise<DivisionDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertDivisionDto, {cancelToken: source.token})
      .then( response => response.data);
};

export const deleteDivision = (id: number, source: CancelTokenSource): Promise<DivisionDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then( response => response.data);
};

export const getAllActiveDivisionsByCompany = (companyId: string,
                                         source: CancelTokenSource): Promise<Array<DivisionDto>> => {
  return axios
      .get(`${apiUri}`, {params: {companyId: companyId}, cancelToken: source.token})
      .then(response => response.data);
};
